<script setup lang="ts">
import type { Operator } from '~/entities/operator'

const props = withDefaults(
  defineProps<{
    operator: Operator
    size?: string
    fontSize?: string
  }>(),
  {
    fontSize: '19px',
    size: '38px',
  }
)

const iconText = computed(() => {
  return props.operator.name.charAt(0) || 'NaN'
})

const ICON_COLORS = [
  '#F94144',
  '#F3722C',
  '#F8961E',
  '#F9844A',
  '#F9C74F',
  '#90BE6D',
  '#43AA8B',
  '#4D908E',
  '#577590',
  '#277DA1',
]

const iconColor = computed(() => {
  const colorIndex = iconText.value.charCodeAt(0) % ICON_COLORS.length
  return ICON_COLORS[colorIndex]
})
</script>

<template>
  <span class="user-icon">{{ iconText }}</span>
</template>

<style scoped lang="scss">
.user-icon {
  display: inline-block;
  width: v-bind(size);
  height: v-bind(size);
  border-radius: 50%;
  background-color: v-bind(iconColor);
  color: white;
  text-align: center;
  line-height: v-bind(size);
  font-weight: bold;
  font-size: v-bind(fontSize);
}
</style>
